@if (dialogData() && countryForm()) {
  <mat-dialog-content>
    <div class="institute_popup_overlay">
      <div class="institute_popup">
        <div class="institute_title">{{constantVariable.manageInstitution}}<a class="material-icons" mat-dialog-close>close</a></div>
        <div class="institution">
          <div class="campus_form institution_form">
            <app-institution-selection-page [countryList]="countryList()" [showGlobalCountry]="showGlobalCountry()" [globalCountryList]="globalCountryList()" [countryForm]="countryForm()!" [institutionList]="institutionList()"
            (fetchInstitutionList)="getInstitutionList($event)"></app-institution-selection-page>
          </div>
        </div>
        <div class="institute_btn">
          <!--To add a active class in button to active color -->
          <button id="proceedButtonAutomationId" class="proceed_btn" [disabled]="countryForm()!.invalid" [ngClass]="{'active':countryForm()!.valid}" mat-stroked-button (click)="getInstitutionData()">Proceed</button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
} @else {
  @if (countryForm()) {
    <div class="whol_prt">
      <div class="title_h3">
        <h3>{{constantVariable.manageInstitution}}</h3>
      </div>
      <div class="dispy">
        <div class="reg_gry">
          <h4 class="nor_tl fst">Select an institution</h4>
          <!-- waub_slct start here -->
          <app-institution-selection-page [countryList]="countryList()" [showGlobalCountry]="showGlobalCountry()" [globalCountryList]="globalCountryList()" [countryForm]="countryForm()!" [institutionList]="institutionList()"
            (fetchInstitutionList)="getInstitutionList($event)">
          </app-institution-selection-page>
          <div class="insitute_float">
            <div class="d-flex">
              <a id="allInstitutionAutomationId" (click)="redirectToViewAllInstitution()"> <div class="instutitions">{{editableRoles.includes(userRole)? 'CREATE/MANAGE ALL INSTITUTIONS' : readonlyRoles.includes(userRole) ? 'VIEW ALL INSTITUTIONS': ''}}</div></a>
              <div class="waub_btn mr43">
                <input id="proceedButtonAutomationId" type="submit" [ngClass]="{'gbtn':countryForm()!.valid}" value="Proceed" (click)="getInstitutionData()"
                  [disabled]="countryForm()!.invalid">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
